"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allDistict = exports.districtsOf = void 0;
var bd_upazila_json_1 = __importDefault(require("../json/bd-upazila.json"));
var lodash_1 = __importDefault(require("lodash"));
var division_1 = require("../division/division");
var districtsOf = function (division) {
    var filteredDivision = division_1.getDivision(division);
    var uniqueDistrict = lodash_1.default.uniqBy(filteredDivision, "district");
    var district = [];
    uniqueDistrict.forEach(function (d) {
        district.push(lodash_1.default.pick(d, "district"));
    });
    return district.map(function (d) { return d.district; });
};
exports.districtsOf = districtsOf;
var allDistict = function () {
    var uniqueDistrict = lodash_1.default.uniqBy(bd_upazila_json_1.default, "district");
    var district = [];
    uniqueDistrict.forEach(function (d) {
        district.push(lodash_1.default.pick(d, "district"));
    });
    return district.map(function (d) { return d.district; });
};
exports.allDistict = allDistict;
